import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from '../../../core/Loading';
import View from '../../../views/Employee/FoodTickets';

import {
  setIsFoodTickets,
  setFoodTicketsData
} from '../../../../actions/foodTickets';

class FoodTickets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      onErrorLoadData: false
    };
  }

  componentDidMount() {
    const {
      foodTicketsData,
      setIsFoodTicketsHandler,
      setFoodTicketsDataHandler
    } = this.props;
    const currentDate = new Date();

    setIsFoodTicketsHandler(true);

    if (!foodTicketsData) {
      setFoodTicketsDataHandler(
        currentDate.getMonth(),
        currentDate.getFullYear()
      )
        .then(() => {
          this.setState({
            onErrorLoadData: false
          });
        })
        .catch(() => {
          this.setState({
            onErrorLoadData: true
          });
        })
        .finally(() => {
          this.setState({
            loading: false
          });
        });
    } else {
      this.setState({
        loading: false
      });
    }
  }

  componentWillUnmount() {
    const { setIsFoodTicketsHandler } = this.props;

    setIsFoodTicketsHandler(false);
  }

  getRender = () => {
    const { foodTicketsData } = this.props;
    const { loading, onErrorLoadData } = this.state;

    if (loading) {
      return <Loading size="xl" />;
    }
    if (onErrorLoadData) {
      return (
        <p>Lo sentimos, pero no tenemos datos para la fecha seleccionada</p>
      );
    }
    return <View data={foodTicketsData} />;
  };

  render() {
    return this.getRender();
  }
}

const mapStateToProps = ({ foodTickets: { foodTicketsData } }) => ({
  foodTicketsData
});

const mapDispatchToProps = dispatch => ({
  setIsFoodTicketsHandler: state => setIsFoodTickets(dispatch, state),
  setFoodTicketsDataHandler: (month, year) =>
    setFoodTicketsData(dispatch, month, year)
});

export default connect(mapStateToProps, mapDispatchToProps)(FoodTickets);
